import React from "react";
import about from "../images/about-us.jpg";
import Director from "../images/DhootSir2.png";

function A(){
    return (
        <div className="flex flex-col">
            <img className="h-72 w-full" src={about} alt="" />
            <div className="flex flex-col p-10 md:p-16 lg:p-20 gap-5">
                <h2 className="flex text-3xl md:text-4xl lg:text-5xl text-black justify-center">About Us</h2>
                <p className="flex text-justify text-xl md:text-2xl text-black/90">
                    Dhoot Physics Academy specializes in preparing students for the JEE, NEET 
                    and other competitive exams. We provide personalized instruction and 
                    support to help students master the concepts and problem-solving skills 
                    required to excel in these exams. Our curriculum is specifically tailored 
                    to match the syllabus and exam patterns of the JEE and NEET, and includes 
                    a comprehensive range of study materials, practice sheets, and test series 
                    to help students prepare thoroughly.
                </p>
            </div>
            {/* flex justify-evenly gap-20 p-6 md:p-8 lg:p-10 lg:w-3/4 mx-auto */}
            <div className="grid md:grid-cols-2 gap-5 p-8 md:gap-12 md:p-12 lg:gap-20 lg:p-20">
                <div className="flex flex-col rounded-xl shadow-xl p-10 gap-5">
                    <h2 className="flex justify-center text-xl md:text-2xl lg:text-3xl">Vision</h2>
                    <p className="flex text-md md:text-lg text-justify">Dhoot Physics Academy envisions being the leading coaching institute in Aurangabad, dedicated to enabling students to achieve outstanding results in IIT JEE and NEET exams.</p>
                </div>
                <div className="flex flex-col rounded-xl shadow-xl p-10 gap-5">
                    <h2 className="flex justify-center text-xl md:text-2xl lg:text-3xl">Mission</h2>
                    <p className="flex text-md md:text-lg text-justify">Through our comprehensive curriculum, supportive learning environment, and personalized guidance, we aim to guide students towards academic excellence, enabling them to secure admissions in prestigious institutions.</p>
                </div>
            </div>
            <div className="flex flex-col gap-y-10 lg:gap-0 lg:flex-row p-4 md:p-8 lg:p-16">
                <div className="flex flex-col lg:w-1/2 lg:p-10 justify-center">
                    <img className="w-auto  shadow-xl rounded-2xl" src={Director} alt="" />
                </div>
                <div className="flex flex-col lg:w-1/2 p-4 md:p-6 lg:p-10 gap-5">
                    <h3 className="flex justify-center text-2xl md:text-3xl lg:text-4xl">Director's Message</h3>
                    <p className="flex text-justify text-md md:text-lg">
                    Welcome to Dhoot Physics Academy! We are committed to providing the 
                    best coaching and guidance for competitive exams like IIT JEE, NEET, CET. 
                    Our institute is built on the pillars of expertise, 
                    dedication, and a passion for empowering students to achieve their goals.
                    We understand the challenges that students face while preparing 
                    for these highly competitive exams. Therefore, our team of experienced 
                    faculty members is dedicated to delivering top-quality education, 
                    ensuring that students not only grasp the concepts but also develop 
                    strong problem-solving skills. 
                    Our aim is to provide students with the tools and 
                    resources they need to excel in their exams and secure admissions to 
                    prestigious institutions. Join us at Dhoot Physics Academy and 
                    experience the difference in your exam preparation.
                    </p>
                    <p className="flex justify-end text-2xl">- Santosh.B.Dhoot</p>
                </div>
            </div>
        </div>
    )
}

export default A;